import {mapState} from "vuex";

export default {

    data() {
        return {
            intervalId: null
        };
    },

    computed: mapState({
        filesToStateCheck: state => state.filesToStateCheck,
        filesToRemoveFromStateCheck: state => state.filesToRemoveFromStateCheck,
        ceremony: state => state.ceremony
    }),

    mounted() {
        this.$store.dispatch('clearFilesToStateCheck');

        this.intervalId = setInterval(() => {
            this.checkFilesState();
        }, 10000);
    },

    methods: {

        async checkFilesState() {
            if (this.filesToRemoveFromStateCheck.length && this.ceremony) {
                this.$store.dispatch('updateCeremony', this.ceremony.code);

                await this.$store.dispatch('checkFilesToRemoveFromStateCheck');
            }

            if (this.filesToStateCheck.length <= 0) {
                return;
            }

            try {
                const response = await this.$http.get(`/api/ceremonies/code/${this.code}/files-state`, {
                    params: {
                        files: this.filesToStateCheck.map(file => file.id)
                    }
                });

                await this.$store.dispatch('updateFilesToStateCheck', response.data);

                if (this.filesToRemoveFromStateCheck.length && this.ceremony) {
                    this.$store.dispatch('updateCeremony', this.ceremony.code);

                    this.$store.dispatch('checkFilesToRemoveFromStateCheck');
                }
            } catch (exception) {
                console.error('Cannot get file state');
            }
        }

    },

    beforeDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    },
}
